import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import Cookies from 'js-cookie';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
	const [socket, setSocket] = useState(null);

	useEffect(() => {
		const token = Cookies.get('authToken') || localStorage.getItem('authToken');
		if (!token) return;

		const newSocket = io(SOCKET_URL, {
			autoConnect: true,
			reconnection: true,
			reconnectionAttempts: 10,
			reconnectionDelay: 1000,
			transports: ['websocket'],
			auth: {
				token: `Bearer ${token}`,
			},
		});
		setSocket(newSocket);

		newSocket.on('connect', () => {});
		newSocket.on('disconnect', (reason) => {});
		newSocket.on('connect_error', (err) => {});

		return () => {
			newSocket.disconnect();
		};
	}, []);

	return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
